import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducers from './reducers';
import sagas from './sagas';

const persistConfig = {
  key: 'tree-survey',
  storage,
  blacklist: ['api', 'trees', 'jobs', 'groups', 'sites'],
  timeout: null,
};

const sagaMiddleware = createSagaMiddleware();

export let store = null;

export function configureStore(initialState) {
  const persistedReducer = persistReducer(persistConfig, rootReducers);

  store = createStore(
    persistedReducer,
    initialState,
    compose(applyMiddleware(sagaMiddleware))
  );

  sagaMiddleware.run(sagas);
  const persistor = persistStore(store);
  return { store, persistor };
}
